import styled, { css } from 'styled-components'

import { Carousel, Image } from '@/components'

type ObjectivesContainerProps = {
  color: string
  elementVisible: boolean
  hasDoubleDescription: boolean
}
export const ObjectivesContainer = styled.div<ObjectivesContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1170px;
  gap: 40px;

  .title {
    width: 100%;
    max-width: 545px;
    position: relative;
    z-index: 1;
    .bar {
      position: absolute;
      left: 0;
      bottom: 0.7rem;
      width: 0;
      border: 2px solid ${(props) => props.color};
      z-index: -1;
      transition: width 0.8s ease-in;

      ${({ elementVisible }) =>
        elementVisible &&
        css`
          width: 100%;
        `}
    }

    @media (max-width: 700px) {
      .bar {
        bottom: -0.2rem;
      }
    }
  }

  .descriptions {
    width: 100%;
    display: flex;
    gap: 80px;
    align-items: flex-start;
    justify-content: space-around;
    margin-bottom: 80px;

    ${({ hasDoubleDescription }) =>
      hasDoubleDescription &&
      `p {
        max-width: 42.74%;
      }
    `}

    @media (max-width: 700px) {
      flex-direction: column;
      gap: 16px;
      margin-bottom: 40px;

      p {
        max-width: 100%;
      }
    }

    .double-carousel {
      display: flex;
      flex-direction: column;
      gap: 100px;
    }
  }
`

export const Slider = styled(Carousel)``

type ImageProps = {
  width: number
  height: number
}
export const ImageCarousel = styled(Image)<ImageProps>`
  width: 100%;
  height: 100%;
  max-width: ${(props) => props.width}px;
  max-height: ${(props) => props.height}px;

  object-fit: cover;
`
